/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { AllFilters } from './components/all-filters';
import { IOfferListFilters } from './types';
import {
  FilterPanelWrapper,
  FiltersDropDown,
  FilterBlocker,
  SortingText,
  FilterMobileHeader,
  CloseButton,
} from './styles';
import { SortingByText } from '../price-list-panel/utils/soring-by-text';
import { IconClose } from '@prisjakt/ui/icon';

export const OfferListFilters = ({
  visible,
  closeHandler,
  filters,
  onFilterChanged,
}: IOfferListFilters) => {
  const renderFilters = () => (
    <FilterPanelWrapper>
      <FilterMobileHeader>
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
        <CloseButton onClick={() => closeHandler()}>
          <IconClose />
        </CloseButton>
      </FilterMobileHeader>
      <AllFilters filters={filters} onToggleFilter={onFilterChanged} />
      <SortingText>
        <SortingByText mobile />
      </SortingText>
    </FilterPanelWrapper>
  );

  if (!visible) {
    return null;
  }

  return (
    <>
      <FilterBlocker onClick={() => closeHandler()} />
      <FiltersDropDown>{renderFilters()}</FiltersDropDown>
    </>
  );
};
